import { ChevronDown, ChevronUp } from 'lucide-react'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { useProfileWallet } from '@/hooks/use-profile-wallet'
import { useDepositModal } from '@/context/DepositModalContext'
import { selectIsWalletConnectOpen, setWalletConnectOpen } from '@/store/slices/paymentSlice'
import { cn } from '@/lib/utils'
import { BalanceList } from '@/components/profile/balance/BalanceList'
import { CurrencyGrid } from '@/components/profile/currency/CurrencyGrid'
import { WalletProviderList } from './WalletProviderList'
import { Button } from '../ui/button'

export function WalletConnectPanel() {
	const dispatch = useAppDispatch()
	const { openDeposit } = useDepositModal()
	const isOpen = useAppSelector(selectIsWalletConnectOpen)
	const {
		balances,
		availableCurrencies,
		gridSelectedCurrencyCodes,
		isCurrenciesLoading,
		isBalancesLoading,
		isCurrenciesError,
		isBalancesError,
		handleGridCurrencyChecked,
		handleApplySelectedCurrencies,
		canApplySelectedCurrencies,
		isEnablingBalances,
		handleDisableBalance,
		disablingCurrencyCode,
		handleSetDefaultBalance,
		settingDefaultCurrencyCode,
	} = useProfileWallet()

	const handleTogglePanel = () => {
		dispatch(setWalletConnectOpen(!isOpen))
	}

	return (
		<section className='overflow-hidden rounded-2xl border border-border bg-card shadow-[0_4px_12px_0_hsl(var(--background)/0.2)]'>
			<button type='button' onClick={handleTogglePanel} className='flex w-full items-center justify-between px-4 py-4 text-left sm:px-6' aria-expanded={isOpen}>
				<h2 className='text-base font-semibold tracking-[-0.24px] text-foreground sm:text-lg'>Wallet Connect</h2>
				{isOpen ? <ChevronUp className='h-5 w-5 text-muted-foreground' /> : <ChevronDown className='h-5 w-5 text-muted-foreground' />}
			</button>

			{isOpen && (
				<div className='flex flex-col gap-4 border-t border-border px-4 pb-6 pt-4 sm:px-6'>
					{(isBalancesError || isCurrenciesError) && (
						<p className='rounded-xl border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm text-destructive'>
							Unable to load wallet data. Please try again later.
						</p>
					)}

					<BalanceList
						balances={balances}
						isLoading={isBalancesLoading}
						settingDefaultCurrencyCode={settingDefaultCurrencyCode}
						disablingCurrencyCode={disablingCurrencyCode}
						onDeposit={openDeposit}
						onSetDefaultBalance={handleSetDefaultBalance}
						onDisableBalance={handleDisableBalance}
					/>

					<CurrencyGrid
						currencies={availableCurrencies}
						selectedCodes={gridSelectedCurrencyCodes}
						onCurrencyCheckedChange={handleGridCurrencyChecked}
						isLoading={isCurrenciesLoading || isBalancesLoading}
					/>

					<Button variant='secondary' onClick={handleApplySelectedCurrencies} disabled={!canApplySelectedCurrencies}>
						<span>Use Currency</span>
					</Button>

					<WalletProviderList />
				</div>
			)}
		</section>
	)
}
